<template>
  <div class="modal fade" id="cameraModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-identify">
      <div class="modal-content modal-content-identify modal-content-camera" v-bind:class="{'modal-content-camera-small': action == 'edit' }">
        <div class="modal-body modal-body-identify modal-body-location">
          <div class="container-fluid identify-modal-container camera-modal-container right-container overflow-visible">
            <label>Camera name</label><br>
            <input type="text" class="location-name-input" v-model="cameraName"><br><br>
            <label>Location</label><br>
            <camera-location-filter :locations='locations' :initialLocation='item.location' @locationSelected="location = $event"/><br>
            <div class="row camera-types" v-if="action == 'add'">
              <a class="col camera-type-hd" @click="selectedHd = 1" v-bind:class="{'camera-type-selected': selectedHd }">
                <img src=".././assets/images/img3.png" alt="" height="90px" width="90px">
                <br>HD feed
              </a>
              <a class="col camera-type-thermal" @click="selectedHd = 0" v-bind:class="{'camera-type-selected': !selectedHd }">
                <img src=".././assets/images/img_thermo.png" alt="" height="90px" width="90px">
                <br>Thermal feed
              </a>
            </div>
            <div class="row data-hd" v-if="selectedHd && action == 'add'">
              <label>Stream type</label>
              <camera-location-filter :streamTypes='streamTypes'/><br><br>
              <label>Stream source</label><br>
              <input type="text" class="location-name-input" v-model="streamSource">
              <a href="#" v-if="action == 'add'" @click.prevent="testCamera()" class="mx-auto align-self-center k-light-blue test-camera">Test HD camera</a>
            </div>
            <div class="row data-thermal" v-if="!selectedHd && action == 'add'">
              <label>Thermal type</label>
              <camera-location-filter :streamTypes='streamTypes'/><br><br>
              <label>Thermal source</label><br>
              <input type="text" class="location-name-input" v-model="thermalSource">
              <a href="#" v-if="action == 'add'" @click.prevent="testCamera()" class="mx-auto align-self-center k-light-blue test-camera">Test Thermal camera</a>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-identify modal-footer-location">
          <button type="button" class="btn btn-primary my-btn btn-identify btn-location-modal" @click.prevent="storeCamera();" data-dismiss="modal">
            <span v-if="action == 'add'">Add camera</span>
            <span v-if="action == 'edit'">Edit camera</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CameraLocationFilter from '@/components/filters/CameraLocation';

  export default {
    name: 'CameraModal',
    components: {
      CameraLocationFilter,
    },
    props: {
      item: {
      },
      action: '',
      locations: '',
    },
    data() {
      return {
        cameraName: '',
        selectedHd: 1,
        streamTypes: 'IP',
        streamSource: '',
        thermalSource: '',
        location: {},
      };
    },
    watch: {
      item(newVal) {
        this.cameraName = newVal.name;
        this.streamSource = newVal.stream_source;
        this.thermalSource = newVal.thermal_source;
        this.location = newVal.location;
      }
    },
    methods: {
      storeCamera() {
        if(this.action == 'add') {
          this.addCamera();
        }
        if(this.action == 'edit') {
          this.editCamera();
        }
      },
      addCamera() {
        let data = new FormData();

        data.set('name', this.cameraName);
        data.set('location_id', this.location.id);
        data.set('stream_type', 1); // 3 = IP
        data.set('stream_source', this.streamSource);
        data.set('thermal_type', 1); // 3 = IP
        data.set('thermal_source', this.thermalSource);

        this.axios.post(`/camera`, data)
          .then(() => {
            this.$emit('snotify', {status: 'success', message: 'Camera successfully added.'});
            this.$emit('cameras-changed');
            this.cameraName = this.streamSource = this.thermalSource = '';
          })
          .catch(() => this.$emit('snotify', {status: 'error', message: 'An error occured.'}));
      },

      editCamera() {
        let data = new FormData();

        data.set('camera_id', this.item.id);
        data.set("fields", JSON.stringify(['name', 'location_id']));
        data.set("values", JSON.stringify([this.cameraName, this.location.id]));

        this.axios.put(`/camera`, data)
          .then(() => {
            this.$emit('snotify', {status: 'success', message: 'Camera successfully edited.'});
            this.$emit('cameras-changed');
            this.cameraName = this.streamSource = this.thermalSource = '';
          })
          .catch(() => this.$emit('snotify', {status: 'error', message: 'An error occured.'}));
      },
      testCamera() {
        let data = {
          stream_type: 3,
          stream_source: this.selectedHd ? this.streamSource : this.thermalSource
        };

        this.axios.get(`/camera_snapshot`, { params: data })
          .then(() => {
            this.$emit('snotify', {status: 'success', message: 'Camera successfully tested.'});
          })
          .catch(() => this.$emit('snotify', {status: 'error', message: 'Camera check failed.'}));
      }
    }
  };
</script>
